var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyCart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 508,
    viewBox: "0 0 512 508",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2894",
    "data-name": "Rectangle 2894",
    width: 512,
    height: 508,
    transform: "translate(0 0.016)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2878",
    "data-name": "Rectangle 2878",
    width: 3.268,
    height: 3.187,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2879",
    "data-name": "Rectangle 2879",
    width: 35.62,
    height: 25.451,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2880",
    "data-name": "Rectangle 2880",
    width: 2.986,
    height: 3.053,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2881",
    "data-name": "Rectangle 2881",
    width: 18.325,
    height: 35.922,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2892",
    "data-name": "Rectangle 2892",
    width: 42.35,
    height: 18.494,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Empty_Cart",
    transform: "translate(0.138 -0.016)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8757",
    "data-name": "Group 8757",
    transform: "translate(-0.138 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8756",
    "data-name": "Group 8756"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8755",
    "data-name": "Group 8755",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7724",
    "data-name": "Path 7724",
    d: "M1.158,271.875s2.952,91.51,79.342,152.5,182.243,65.361,267.936,71.155,151.512-42.717,161.432-116.047-55.56-94.857-91.087-178.33S386.415,90.244,311.244,38.9,118.48,19.089,56.825,107.041,1.158,271.875,1.158,271.875",
    transform: "translate(0.061 -1.083)",
    fill: "#f1f3f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7725",
    "data-name": "Path 7725",
    d: "M1.158,271.875s2.952,91.51,79.342,152.5,182.243,65.361,267.936,71.155,151.512-42.717,161.432-116.047-55.56-94.857-91.087-178.33S386.415,90.244,311.244,38.9,118.48,19.089,56.825,107.041,1.158,271.875,1.158,271.875Z",
    transform: "translate(0.061 -1.083)",
    fill: "none",
    stroke: "#b5bccc",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7726",
    "data-name": "Path 7726",
    d: "M318.267,152.35l7.741,4.234-7.741,4.234-4.234,7.741-4.234-7.741-7.741-4.234,7.741-4.234,4.234-7.741Z",
    transform: "translate(-22.911 -11.034)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7727",
    "data-name": "Path 7727",
    d: "M293.578,141.2l2.636,1.442-2.636,1.442-1.442,2.637-1.442-2.637-2.637-1.442,2.637-1.442,1.442-2.636Z",
    transform: "translate(-21.843 -10.574)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7728",
    "data-name": "Path 7728",
    d: "M265.726,215.712l2.636,1.442-2.636,1.442-1.442,2.636-1.442-2.636-2.636-1.442,2.636-1.442,1.442-2.636Z",
    transform: "translate(-19.718 -16.259)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7729",
    "data-name": "Path 7729",
    d: "M428.5,147.2l4.758,2.6-4.758,2.6-2.6,4.758-2.6-4.758-4.758-2.6,4.758-2.6,2.6-4.758Z",
    transform: "translate(-31.8 -10.869)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7730",
    "data-name": "Path 7730",
    d: "M466.008,222.605l4.3,3.306-5.1,1.836-3.3,4.3-1.837-5.1-4.3-3.306,5.1-1.836,3.306-4.3Z",
    transform: "translate(-34.64 -16.597)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7731",
    "data-name": "Path 7731",
    d: "M387.688,177.486l3.323,1.818-3.323,1.817-1.818,3.323-1.817-3.323L380.73,179.3l3.323-1.818,1.817-3.323Z",
    transform: "translate(-28.915 -13.29)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7732",
    "data-name": "Path 7732",
    d: "M457.52,453.923a9.519,9.519,0,0,1,4.933,5.588,16.8,16.8,0,0,1,.655,7.57c-.556,4.913-3.347,9.872-6.353,13.8-4.137-3.611-5.089-9.908-5.37-13.134-.446-5.1,1.844-14.581,6.135-13.821",
    transform: "translate(-34.302 -34.634)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7733",
    "data-name": "Path 7733",
    d: "M462.394,491.041a8.122,8.122,0,0,1,2.624-7.721,10.783,10.783,0,0,1,7.955-2.485,4.544,4.544,0,0,1,3.492,1.568,3.475,3.475,0,0,1,.054,3.52,7.043,7.043,0,0,1-2.607,2.567c-3.584,2.249-7.465,3.768-11.518,2.551",
    transform: "translate(-35.132 -36.688)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7734",
    "data-name": "Path 7734",
    d: "M456.665,506.5a5.779,5.779,0,0,1,.148-1.009c.129-.709.3-1.626.5-2.728a28.527,28.527,0,0,1,2.815-8.715,17.447,17.447,0,0,1,6.254-6.647,11.859,11.859,0,0,1,2.55-1.128,7.186,7.186,0,0,1,.734-.187.752.752,0,0,1,.262-.036,18.469,18.469,0,0,0-3.416,1.568,18.012,18.012,0,0,0-6.072,6.6,30.675,30.675,0,0,0-2.88,8.591c-.25,1.144-.454,2.07-.612,2.706a5.343,5.343,0,0,1-.284.979",
    transform: "translate(-34.709 -37.088)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7735",
    "data-name": "Path 7735",
    d: "M456.817,461.912a2.086,2.086,0,0,1,.051.442c.019.326.044.746.075,1.266.059,1.1.124,2.691.187,4.66.127,3.936.227,9.377.2,15.387s-.174,11.451-.335,15.385c-.08,1.968-.159,3.56-.227,4.659q-.053.777-.086,1.264a2.133,2.133,0,0,1-.054.441,2.057,2.057,0,0,1-.018-.443c0-.328.011-.748.018-1.268.028-1.145.066-2.726.114-4.66.1-3.936.2-9.373.23-15.379s-.034-11.443-.1-15.379c-.03-1.936-.055-3.516-.073-4.662,0-.522-.006-.941-.007-1.268a2.1,2.1,0,0,1,.021-.444",
    transform: "translate(-34.705 -35.246)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7736",
    "data-name": "Path 7736",
    d: "M453.381,493.918A19,19,0,0,0,443.006,480c-1.382-.662-3.187-1.095-4.323-.067s-.884,2.878-.327,4.309a16.233,16.233,0,0,0,14.927,10.078",
    transform: "translate(-33.276 -36.575)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7737",
    "data-name": "Path 7737",
    d: "M444.155,485.1a4.861,4.861,0,0,1,.878.383,9.2,9.2,0,0,1,.992.528c.371.232.821.458,1.263.792a16.542,16.542,0,0,1,1.445,1.087,18.817,18.817,0,0,1,1.538,1.4,21.141,21.141,0,0,1,2.922,3.753,20.711,20.711,0,0,1,1.924,4.352,18.2,18.2,0,0,1,.487,2.02,15.494,15.494,0,0,1,.248,1.792,13.968,13.968,0,0,1,.069,1.49,8.676,8.676,0,0,1-.033,1.123,4.933,4.933,0,0,1-.106.951c-.081,0,.059-1.366-.182-3.539a16.288,16.288,0,0,0-.287-1.76,19.125,19.125,0,0,0-.51-1.981,21.528,21.528,0,0,0-1.917-4.265,22.03,22.03,0,0,0-2.851-3.708,19.427,19.427,0,0,0-1.493-1.4,17.81,17.81,0,0,0-1.4-1.108c-1.777-1.274-3.022-1.841-2.986-1.91",
    transform: "translate(-33.754 -37.016)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7738",
    "data-name": "Path 7738",
    d: "M204.359,135.021c1.206,0,14.6,3.218,18.363,9.856s5.388,30.935,5.388,30.935,1.083,17.09-1.26,25.3C224.476,209.424,216.84,249.621,214,257.8c-3.639,10.493-8.8,27.808-8.8,27.808L161.113,254.3Z",
    transform: "translate(-12.157 -10.303)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7739",
    "data-name": "Path 7739",
    d: "M220.16,93.971c-1.9,4.118-1.29,8.941-.17,13.337s2.721,8.758,2.69,13.294c-.047,6.665-1.738,15.77-15.241,11.469-8.224-2.619-.66,21.788-5.1,29.188a12.491,12.491,0,0,1-3.189,3.96c-3.317,2.36-7.884.991-11.688-.456-1.216-.464-2.6-1.111-2.878-2.382a3.964,3.964,0,0,1,.244-1.966L204.987,93.5",
    transform: "translate(-13.944 -7.134)",
    fill: "#858d9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7740",
    "data-name": "Path 7740",
    d: "M196.707,143.813c7.742-1.828,10.121-5.677,10.212-12.487l.117-8.661s8.57-.445,10.569-13.21a126.964,126.964,0,0,0,1.3-25.111c-.5-7.654-8.452-21.151-16.077-20.327L181.888,74.206a4.487,4.487,0,0,0-4.006,4.56l1.627,49.481",
    transform: "translate(-13.436 -4.882)",
    fill: "#ffc0aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7741",
    "data-name": "Path 7741",
    d: "M216.719,95.487a1.636,1.636,0,0,1-1.574,1.654,1.565,1.565,0,0,1-1.69-1.471,1.637,1.637,0,0,1,1.572-1.655,1.566,1.566,0,0,1,1.692,1.472",
    transform: "translate(-16.151 -7.174)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7742",
    "data-name": "Path 7742",
    d: "M219.324,92.24c-.145.275-1.584-.462-3.3-.084-1.725.35-2.763,1.612-3,1.417-.115-.084-.008-.548.44-1.114a4.149,4.149,0,0,1,2.34-1.422,4.066,4.066,0,0,1,2.7.357c.633.339.907.72.833.846",
    transform: "translate(-16.114 -6.94)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7743",
    "data-name": "Path 7743",
    d: "M198.418,95.287a1.637,1.637,0,0,1-1.574,1.655,1.567,1.567,0,0,1-1.69-1.471,1.638,1.638,0,0,1,1.573-1.656,1.566,1.566,0,0,1,1.691,1.472",
    transform: "translate(-14.754 -7.158)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7744",
    "data-name": "Path 7744",
    d: "M200.409,94.061c-.279.171-1.288-1.206-3.127-1.737-1.83-.557-3.463.039-3.6-.254-.067-.133.266-.491.985-.766a4.718,4.718,0,0,1,2.96-.085,4.579,4.579,0,0,1,2.405,1.673c.434.617.506,1.095.372,1.168",
    transform: "translate(-14.642 -6.946)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7745",
    "data-name": "Path 7745",
    d: "M208.007,105.2a11.668,11.668,0,0,1,2.859-.523c.45-.047.875-.137.95-.444a2.3,2.3,0,0,0-.3-1.332q-.639-1.631-1.338-3.421c-1.858-4.871-3.2-8.876-3.007-8.949s1.862,3.816,3.72,8.686q.671,1.8,1.281,3.442a2.6,2.6,0,0,1,.237,1.764,1.13,1.13,0,0,1-.738.659,3.053,3.053,0,0,1-.764.108,11.476,11.476,0,0,1-2.9.01",
    transform: "translate(-15.67 -6.908)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7746",
    "data-name": "Path 7746",
    d: "M208.033,127.274a32.46,32.46,0,0,1-17.1-4.521s4.284,9.11,17.051,7.888Z",
    transform: "translate(-14.432 -9.367)",
    fill: "#fb987c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7747",
    "data-name": "Path 7747",
    d: "M207.309,110.86a4.7,4.7,0,0,0-3.384-2.236,2.016,2.016,0,0,0-1.984,1.106,3.192,3.192,0,0,0,.284,2.927,2.693,2.693,0,0,0,2.669,1.29,4.505,4.505,0,0,0,2.2-1.435,1.579,1.579,0,0,0,.447-.632,1.085,1.085,0,0,0-.139-.923",
    transform: "translate(-15.254 -8.288)",
    fill: "#fb987c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7748",
    "data-name": "Path 7748",
    d: "M202.448,107.741c.286-.018.295,1.895,1.933,3.247s3.673,1.138,3.688,1.406c.027.12-.453.372-1.313.4a4.756,4.756,0,0,1-3.079-1.065,4.14,4.14,0,0,1-1.5-2.723c-.075-.8.138-1.273.268-1.262",
    transform: "translate(-15.289 -8.221)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7749",
    "data-name": "Path 7749",
    d: "M201.963,85.376c-.22.459-1.947.061-4.027.105-2.082,0-3.8.442-4.029-.013-.1-.216.232-.635.947-1.031a7.008,7.008,0,0,1,6.139-.071c.724.379,1.068.791.971,1.01",
    transform: "translate(-14.658 -6.386)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7750",
    "data-name": "Path 7750",
    d: "M219.821,88.015c-.386.4-1.892-.018-3.7-.042-1.811-.074-3.347.263-3.7-.156-.154-.2.089-.6.76-.981a6.077,6.077,0,0,1,3.012-.65,5.965,5.965,0,0,1,2.953.809c.639.413.849.825.679,1.02",
    transform: "translate(-16.068 -6.576)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7751",
    "data-name": "Path 7751",
    d: "M147.747,133.09c2.783-4.5,11.766-15.28,14.947-22.705,2.269-5.3,3.978-23.889,8.817-33.459s10.538-13.441,16.13-14.946a12.855,12.855,0,0,1,12.311,2.8c2.525,2.258,3.387,8.831,3.387,8.831s-13.489,3-18.031,10.691c-5.218,8.835-6.483,13.279-6.483,13.279l-1.689,4.833s1.58,9.355,2.161,13.979-.345,8.918-4.151,10.794l-7.656,5.41s4.156,44.718,3.695,45.071c-1.143.872-10.723-1.062-19.387-3.05-1.683-.386-2.6-16.165-2.6-16.165l-2.532,14.772-6.519-1.484s1.914-29.454,7.6-38.646",
    transform: "translate(-10.557 -4.69)",
    fill: "#858d9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7752",
    "data-name": "Path 7752",
    d: "M207.731,73.759a10.959,10.959,0,0,1,11.194,7.9c1.289,3.94,2.272,15.32,2.272,15.32s1.128-9.035.712-14.193-2.989-11.68-6.942-15.291c-3.844-3.512-7.086-5.16-13.96-4.743a12.117,12.117,0,0,1,4.5,3.849c.881,1.305,1.095,2.257,2.226,7.159",
    transform: "translate(-15.201 -4.783)",
    fill: "#858d9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7753",
    "data-name": "Path 7753",
    d: "M181.465,100.976a3.871,3.871,0,0,0-5.665-3.294c-1.344.777-2.371,2.339-2.248,5.337.33,7.995,8.288,6.015,8.293,5.785,0-.142-.214-4.521-.38-7.828",
    transform: "translate(-13.105 -7.417)",
    fill: "#ffc0aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7754",
    "data-name": "Path 7754",
    d: "M179.447,106.076c-.036-.024-.136.1-.367.221a1.394,1.394,0,0,1-1.04.065c-.857-.275-1.624-1.587-1.722-3.026a4.621,4.621,0,0,1,.308-2.011,1.609,1.609,0,0,1,1-1.112.71.71,0,0,1,.837.348c.116.219.073.381.115.393.023.019.166-.141.088-.468a.887.887,0,0,0-.334-.489,1.054,1.054,0,0,0-.779-.171,1.957,1.957,0,0,0-1.4,1.3,4.739,4.739,0,0,0-.392,2.248c.118,1.609,1,3.083,2.174,3.369a1.491,1.491,0,0,0,1.265-.263c.24-.208.275-.388.247-.4",
    transform: "translate(-13.274 -7.616)",
    fill: "#fb987c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7755",
    "data-name": "Path 7755",
    d: "M174.042,73.256a57.523,57.523,0,0,0-9.811,23.273c-.938,5.258-1.253,10.936-4.441,15.222-1.675,2.252-4.067,3.985-5.3,6.506-1.343,2.741-1.144,6.089-2.717,8.707-1.714,2.853-5.128,4.2-7.361,6.667-4.2,4.648-3.27,11.823-4.987,17.849A20.146,20.146,0,0,1,133,161.359c-1.048.875-2.326,2.02-1.935,3.329a3.113,3.113,0,0,0,1.753,1.648c2.42,1.233,4.652,5.951,7.319,6.458.552-14.37,7.528-31.629,15.091-43.86,4.317-6.982,9.081-13.958,10.784-21.988,1.122-5.287.851-10.764,1.44-16.136s2.238-10.967,6.3-14.531",
    transform: "translate(-9.859 -5.59)",
    fill: "#858d9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7756",
    "data-name": "Path 7756",
    d: "M174.667,109.171c-.1.119-.832-.22-1.8-1.289a10.065,10.065,0,0,1-2.313-5.6,10.313,10.313,0,0,1,.524-4.306,14.061,14.061,0,0,1,2.463-4.237,33.089,33.089,0,0,1,3.653-3.7c1.328-1.181,2.762-2.341,4.286-3.45a56.037,56.037,0,0,1,9.126-5.418c2.978-1.4,5.7-2.3,7.813-3.319a17.71,17.71,0,0,0,4.6-2.956c.952-.881,1.411-1.486,1.585-1.39.137.069-.025.858-.829,2.043a14,14,0,0,1-4.5,3.9c-2.149,1.3-4.858,2.392-7.617,3.836A68.4,68.4,0,0,0,183,88.657c-1.462,1.065-2.847,2.162-4.144,3.271a35.712,35.712,0,0,0-3.5,3.335,12.78,12.78,0,0,0-2.28,3.468,9.042,9.042,0,0,0-.7,3.461,10.888,10.888,0,0,0,1.318,5.118c.625,1.131,1.108,1.718.977,1.862",
    transform: "translate(-12.874 -5.608)",
    fill: "#858d9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7757",
    "data-name": "Path 7757",
    d: "M178.092,110.119a1.388,1.388,0,0,1-.4-.182,7.548,7.548,0,0,1-1.047-.682,9.835,9.835,0,0,1-2.816-3.613,10.036,10.036,0,0,1-.684-6.735,13.6,13.6,0,0,1,4.789-6.769,70.172,70.172,0,0,1,6.812-4.751c2.16-1.356,4.151-2.5,5.846-3.416s3.093-1.609,4.068-2.068c.487-.231.869-.4,1.131-.511a1.419,1.419,0,0,1,.41-.146,11.149,11.149,0,0,1-1.451.835c-.945.513-2.313,1.253-3.98,2.207s-3.633,2.126-5.769,3.5a76.363,76.363,0,0,0-6.737,4.746,13.321,13.321,0,0,0-4.662,6.5,9.805,9.805,0,0,0,.557,6.464,10.219,10.219,0,0,0,2.613,3.608c.811.693,1.345.968,1.315,1.018",
    transform: "translate(-13.052 -6.199)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7758",
    "data-name": "Path 7758",
    d: "M195.706,61.456a5.285,5.285,0,0,1,2.624.173,14,14,0,0,1,5.615,2.961,10.5,10.5,0,0,1,3.261,5.435,8.712,8.712,0,0,1,.24,1.919,1.7,1.7,0,0,1-.067.707c-.092,0-.081-1.006-.524-2.533a11.02,11.02,0,0,0-3.248-5.141,15.39,15.39,0,0,0-5.373-3,23.87,23.87,0,0,0-2.528-.523",
    transform: "translate(-14.796 -4.683)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7759",
    "data-name": "Path 7759",
    d: "M173.545,108.65c.031.033-.37.374-.926,1.123a8.075,8.075,0,0,0-1.474,3.588,7.713,7.713,0,0,0,1.313,5.468,6.54,6.54,0,0,0,5.977,2.9,5.267,5.267,0,0,0,3.166-1.515,6.136,6.136,0,0,0,1.51-2.954,9.047,9.047,0,0,0-.5-5.657,5.272,5.272,0,0,0-2.718-2.648,8.325,8.325,0,0,0-1.4-.356.918.918,0,0,1,.382-.032,3.755,3.755,0,0,1,1.084.2,5.324,5.324,0,0,1,2.974,2.674,9.243,9.243,0,0,1,.632,5.92,6.558,6.558,0,0,1-1.61,3.2,5.739,5.739,0,0,1-3.468,1.675,6.36,6.36,0,0,1-3.772-.746,7.518,7.518,0,0,1-2.654-2.4,7.979,7.979,0,0,1-1.282-5.793,7.813,7.813,0,0,1,1.676-3.654,6.812,6.812,0,0,1,.768-.781c.2-.158.3-.232.315-.219",
    transform: "translate(-12.886 -8.285)",
    fill: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7760",
    "data-name": "Path 7760",
    d: "M138.7,482.506l5.609-24.309-19.737-3.3v17.774l5.494,8.09Z",
    transform: "translate(-9.369 -34.711)",
    fill: "#ffc0aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7761",
    "data-name": "Path 7761",
    d: "M139.806,482.606l-.665,1.054s13.27,18.5,11.307,22l-35.278-22.7,8.034-11.431a24,24,0,0,0,16.6,11.075",
    transform: "translate(-8.651 -35.98)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8742",
    "data-name": "Group 8742",
    transform: "translate(113.571 441.534)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8741",
    "data-name": "Group 8741"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8740",
    "data-name": "Group 8740",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7762",
    "data-name": "Path 7762",
    d: "M124.944,478.077a1.713,1.713,0,0,0-2.054,1,1.648,1.648,0,0,0,.976,2.045,1.808,1.808,0,0,0,2.17-1.074,1.709,1.709,0,0,0-1.251-2.015",
    transform: "translate(-122.805 -478.008)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8745",
    "data-name": "Group 8745",
    transform: "translate(106.519 444.232)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8744",
    "data-name": "Group 8744"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8743",
    "data-name": "Group 8743",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7763",
    "data-name": "Path 7763",
    d: "M115.17,483.679l1.932-2.749,33.1,22.765s1.131,1.694.241,2.686Z",
    transform: "translate(-115.17 -480.93)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_7764",
    "data-name": "Path 7764",
    d: "M140.816,484.771c-.116.169-1.028-.308-2.232-.3-1.2-.023-2.122.442-2.236.272-.138-.135.782-1,2.24-.985s2.367.878,2.228,1.012",
    transform: "translate(-10.266 -36.913)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7765",
    "data-name": "Path 7765",
    d: "M143.8,489.051c-.068.192-1,.006-2.057.357-1.064.321-1.718,1.013-1.885.9-.179-.078.351-1.163,1.67-1.576s2.374.156,2.272.322",
    transform: "translate(-10.532 -37.281)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7766",
    "data-name": "Path 7766",
    d: "M143.312,495.164c-.18-.064.134-1.079,1.183-1.737s2.1-.515,2.077-.325c.006.2-.842.373-1.7.927-.866.534-1.383,1.229-1.565,1.135",
    transform: "translate(-10.795 -37.614)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7767",
    "data-name": "Path 7767",
    d: "M86.656,318.307l17.687,2.368-6.808,19.509-18.969-6.52-1.073-7.209Z",
    transform: "translate(-5.776 -24.289)",
    fill: "#ffc0aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7768",
    "data-name": "Path 7768",
    d: "M79.062,334.5,78,334.052s-14.964,14.932-18.468,13.66l15.516-35.73,11.679,5.649A22.285,22.285,0,0,0,79.062,334.5",
    transform: "translate(-4.405 -23.806)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8748",
    "data-name": "Group 8748",
    transform: "translate(73.976 294.038)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8747",
    "data-name": "Group 8747"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8746",
    "data-name": "Group 8746",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7769",
    "data-name": "Path 7769",
    d: "M82.909,320.082a1.592,1.592,0,0,0-1.227-1.732,1.53,1.53,0,0,0-1.728,1.2,1.68,1.68,0,0,0,1.31,1.828,1.587,1.587,0,0,0,1.658-1.448",
    transform: "translate(-79.939 -318.328)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8751",
    "data-name": "Group 8751",
    transform: "translate(55.123 288.175)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8750",
    "data-name": "Group 8750"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8749",
    "data-name": "Group 8749",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7770",
    "data-name": "Path 7770",
    d: "M75.045,311.981l2.809,1.359-15.9,33.748s-1.384,1.289-2.426.624Z",
    transform: "translate(-59.529 -311.981)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_7771",
    "data-name": "Path 7771",
    d: "M79.3,335.624c-.172-.081.127-.988-.061-2.09-.159-1.107-.722-1.878-.584-2.008.1-.146,1.034.567,1.239,1.906s-.451,2.3-.594,2.193",
    transform: "translate(-5.863 -25.296)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7772",
    "data-name": "Path 7772",
    d: "M75.772,339.005c-.187-.033-.155-.918-.636-1.832-.454-.926-1.187-1.422-1.1-1.593.043-.176,1.118.148,1.694,1.294s.213,2.2.045,2.131",
    transform: "translate(-5.511 -25.603)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7773",
    "data-name": "Path 7773",
    d: "M70.06,339.483c.031-.175,1.009-.039,1.77.824s.787,1.845.609,1.855c-.186.036-.468-.716-1.1-1.415-.619-.713-1.333-1.083-1.275-1.264",
    transform: "translate(-5.209 -25.899)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7774",
    "data-name": "Path 7774",
    d: "M187.185,296.7c-1.57.776-21.332,76.949-27.549,80.09l-12.589,61.945a5.346,5.346,0,0,1,.859,4.01c-.286,2.721-1.432,3.151-1.432,3.151s-18.188,2.292-25.493-3.008c0,0,.859-5.442,1.289-5.872s2.148-49.553,6.588-61.011,10.311-47.692,9.739-55-2.578-24.348-2.149-29.789a51.233,51.233,0,0,1,2.292-10.885Z",
    transform: "translate(-9.094 -21.391)",
    fill: "#858d9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7775",
    "data-name": "Path 7775",
    d: "M193.033,299.965s-6.7,45.929-12.482,53.4-13.657,7.669-15.528,7.984-69.935-24.862-69.935-24.862-1.107-18.538,1.107-21.305c0,0,6.087.277,7.471,2.214l35.414,4.98,13.007-39.565Z",
    transform: "translate(-7.098 -21.58)",
    fill: "#858d9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7776",
    "data-name": "Path 7776",
    d: "M186.711,301.3a4.713,4.713,0,0,1-.147.793q-.193.84-.517,2.247c-.485,2-1.164,4.8-2,8.244l-6.779,27.148c-2.632,10.608-5.373,20.151-8.072,26.8-1.322,3.335-2.542,5.971-3.453,7.757-.442.9-.831,1.574-1.08,2.04a4.743,4.743,0,0,1-.413.692,4.717,4.717,0,0,1,.321-.74c.219-.479.58-1.168.993-2.079.854-1.809,2.019-4.46,3.294-7.8,2.6-6.666,5.282-16.193,7.913-26.8,2.7-10.565,5.14-20.129,6.924-27.112.9-3.426,1.633-6.216,2.156-8.2q.382-1.394.611-2.224a4.655,4.655,0,0,1,.247-.767",
    transform: "translate(-12.396 -22.99)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7777",
    "data-name": "Path 7777",
    d: "M137.6,290.79c.027.007-.039.238-.075.691a18.554,18.554,0,0,0-.058,1.987c.017,1.73.189,4.229.453,7.319.294,3.1.642,6.773,1.027,10.839.326,4.078.978,8.561,1.022,13.315.126,9.543-2.037,17.963-3.337,23.995-.655,2.985-1.189,5.42-1.572,7.172-.175.807-.315,1.455-.422,1.952a3.582,3.582,0,0,1-.182.674,3.514,3.514,0,0,1,.079-.694c.084-.5.193-1.156.328-1.97.3-1.709.781-4.173,1.414-7.209,1.213-6.063,3.3-14.451,3.178-23.914-.042-4.717-.677-9.181-.979-13.275-.345-4.074-.656-7.75-.918-10.858-.217-3.093-.335-5.607-.29-7.347a14.093,14.093,0,0,1,.155-2,2.592,2.592,0,0,1,.177-.677",
    transform: "translate(-10.122 -22.189)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7778",
    "data-name": "Path 7778",
    d: "M103.349,319.962a29.619,29.619,0,0,1-.856,3.04,54.952,54.952,0,0,0-2.158,14.98,29.912,29.912,0,0,1-.036,3.158,2.7,2.7,0,0,1-.156-.84c-.071-.543-.131-1.334-.17-2.313a43.142,43.142,0,0,1,2.173-15.093c.313-.928.595-1.67.817-2.172a2.728,2.728,0,0,1,.386-.761",
    transform: "translate(-7.489 -24.415)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7779",
    "data-name": "Path 7779",
    d: "M83.719,338.3c0,.142-.085.257-.189.257s-.188-.115-.188-.257.084-.257.188-.257.189.115.189.257",
    transform: "translate(-6.222 -25.795)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7780",
    "data-name": "Path 7780",
    d: "M122.871,448.911a31.1,31.1,0,0,1,3.59.509c2.209.348,5.266.787,8.658,1.131s6.477.524,8.711.623a31.466,31.466,0,0,1,3.619.22,3.533,3.533,0,0,1-.973.1c-.626.032-1.534.049-2.656.044-2.243-.007-5.344-.133-8.753-.476s-6.471-.843-8.671-1.285c-1.1-.22-1.986-.417-2.594-.574a3.576,3.576,0,0,1-.933-.292",
    transform: "translate(-9.239 -34.253)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7781",
    "data-name": "Path 7781",
    d: "M199.424,300.118c.218-.144,12.937,0,12.937,0s9.524-46.405,10.656-60.627-23.206,6.589-23.206,6.589Z",
    transform: "translate(-15.08 -17.895)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7782",
    "data-name": "Path 7782",
    d: "M219.564,288.761c.431,2.148,1.1,4.071.822,6.244a5.062,5.062,0,0,1-.494,1.817,5.8,5.8,0,0,1-1.575,1.64L214,301.908c-.462.369-1.128.744-1.59.375a1.261,1.261,0,0,1-.267-1.194,9.509,9.509,0,0,1,1.226-3.444l1.535-6.446-1.578-3.331Z",
    transform: "translate(-16.048 -21.966)",
    fill: "#ffc0aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7783",
    "data-name": "Path 7783",
    d: "M177.035,130.458s12.36,0,19.627,16.148c0,0,21.9,38.189,22.4,54.483,0,0-.254,24.187-4.328,38.444s-15.8,52.034-15.8,52.034-36.651-3.152-44.034-8.5-23.678-4.582-23.678-4.582,9.93-30.3,22.15-48.629,7.383-50.92,7.383-50.92-3.42-48.334,16.272-48.481",
    transform: "translate(-9.876 -9.955)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7784",
    "data-name": "Path 7784",
    d: "M199.842,296.7a3.477,3.477,0,0,1,.594.013c.39.016.967.036,1.718.032,1.5,0,3.7-.088,6.463-.357l-.123.1c2.544-8.95,6.744-24.232,10.3-41.84a267.525,267.525,0,0,0,5.124-36.3c.261-4.686.261-8.486.177-11.107-.06-1.281-.108-2.291-.142-3.02-.01-.321-.018-.58-.024-.787a1.035,1.035,0,0,1,.009-.271,1.1,1.1,0,0,1,.043.265c.019.206.044.464.075.783.057.73.138,1.738.238,3.02.146,2.625.2,6.436-.015,11.135a250.782,250.782,0,0,1-4.982,36.38c-3.559,17.63-7.85,32.9-10.527,41.818l-.029.094-.1.007a59.615,59.615,0,0,1-6.493.225c-.754-.021-1.333-.067-1.723-.107a3.5,3.5,0,0,1-.587-.091",
    transform: "translate(-15.112 -15.503)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7785",
    "data-name": "Path 7785",
    d: "M208.459,137.973c.074-1.376,13.577,19.8,17.1,42.14,1.267,8.036-1.726,18.076-1.726,18.076L198.5,141.315s9.291,9.112,9.96-3.342",
    transform: "translate(-15.009 -10.523)",
    fill: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7786",
    "data-name": "Path 7786",
    d: "M189.21,133.01a18.757,18.757,0,0,1,2.948,2.646,14.708,14.708,0,0,1,2.567,3.875c.769,1.646,1.434,3.589,2.241,5.7l.012.031v.036a18.352,18.352,0,0,0,1.07,5.716,41.424,41.424,0,0,0,2.753,6.02c2.249,4.077,4.684,8.548,7.033,13.307a271.815,271.815,0,0,1,11.823,27.5c1.324,3.6,2.294,6.542,2.957,8.578l.728,2.356a5.1,5.1,0,0,1,.22.832,5.474,5.474,0,0,1-.319-.8q-.3-.863-.818-2.325c-.721-2.016-1.742-4.939-3.107-8.515-2.71-7.153-6.733-16.943-11.943-27.4-2.347-4.754-4.759-9.208-7-13.309a41.107,41.107,0,0,1-2.745-6.1,18.535,18.535,0,0,1-1.039-5.855l.012.067c-.789-2.124-1.427-4.074-2.16-5.706A14.908,14.908,0,0,0,192,135.8a27.264,27.264,0,0,0-2.048-2.08l-.561-.519c-.125-.118-.186-.183-.178-.191",
    transform: "translate(-14.301 -10.149)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7787",
    "data-name": "Path 7787",
    d: "M207.446,224.749c0-.023.211-.029.538.13a2.359,2.359,0,0,1,1.035,1.108,2.622,2.622,0,0,1,.012,2.266,2.6,2.6,0,0,1-4.651-.462,2.623,2.623,0,0,1,.458-2.22,2.354,2.354,0,0,1,1.233-.881c.351-.092.553-.046.552-.022a2.945,2.945,0,0,0-1.487,1.11,2.323,2.323,0,0,0-.3,1.878,2.16,2.16,0,0,0,3.78.375,2.321,2.321,0,0,0,.072-1.9,2.948,2.948,0,0,0-1.24-1.381",
    transform: "translate(-15.452 -17.141)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7788",
    "data-name": "Path 7788",
    d: "M172,228.631c-.018.041-.627-.226-1.758-.609a14.106,14.106,0,0,0-2.092-.547,6.4,6.4,0,0,0-2.794.064,4.369,4.369,0,0,0-2.57,2.035,26.053,26.053,0,0,0-1.605,3.642l-3.42,8.564c-.332.822-.659,1.634-.967,2.4l-.244-.35a29.834,29.834,0,0,1,14.577,3.376,26.954,26.954,0,0,1,3.795,2.391c.427.309.729.586.941.761s.313.28.3.293a13.019,13.019,0,0,1-1.353-.9,32.386,32.386,0,0,0-3.842-2.237,30.614,30.614,0,0,0-14.4-3.172l-.391.012.146-.362.963-2.4c1.226-3.03,2.392-5.913,3.458-8.55a25.146,25.146,0,0,1,1.685-3.692,5.3,5.3,0,0,1,1.26-1.4,4.754,4.754,0,0,1,1.574-.755,6.56,6.56,0,0,1,2.942,0,12.688,12.688,0,0,1,2.107.641c.562.219.985.418,1.269.556a1.721,1.721,0,0,1,.421.24",
    transform: "translate(-11.78 -17.323)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7789",
    "data-name": "Path 7789",
    d: "M224.98,210.527a1.487,1.487,0,0,1,.025-.362c.037-.275.084-.62.141-1.046.145-.963.345-2.292.6-3.96.553-3.456,1.33-8.31,2.259-14.119l0,.026c.115-2.939.259-6.152.325-9.554a51.517,51.517,0,0,0-.191-5.223c-.043-.89-.149-1.786-.274-2.687-.1-.905-.249-1.811-.426-2.721a67.118,67.118,0,0,0-4.6-14.788,69.086,69.086,0,0,0-6.077-11.112,62.178,62.178,0,0,0-5.275-6.724c-.678-.749-1.249-1.289-1.61-1.681a4.8,4.8,0,0,1-.544-.608,4.822,4.822,0,0,1,.615.533c.385.369.981.888,1.684,1.619a55.735,55.735,0,0,1,5.429,6.657A66.845,66.845,0,0,1,223.27,155.9a66.1,66.1,0,0,1,4.668,14.886c.178.918.331,1.833.43,2.748.126.911.231,1.815.273,2.717a50.876,50.876,0,0,1,.178,5.267c-.079,3.415-.24,6.625-.378,9.566v.014l0,.012c-1,5.8-1.844,10.64-2.441,14.089-.3,1.659-.543,2.982-.719,3.94-.083.421-.151.762-.206,1.035a1.4,1.4,0,0,1-.093.351",
    transform: "translate(-15.836 -10.375)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7790",
    "data-name": "Path 7790",
    d: "M205.547,280.331c.514-.235,9.945,3.551,11.82,5.972a4.918,4.918,0,0,1,1.222,3.689s-12.039-5.153-14.5-4.805-4.161,3.911-5.689,1.607-1.762-2.581-1.762-2.581Z",
    transform: "translate(-14.867 -21.39)",
    fill: "#ffc0aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7791",
    "data-name": "Path 7791",
    d: "M179.477,133.01c3.456-.007,12.344,6.736,12.839,24.052.481,16.838-.617,47.267-.617,47.267l14.019,63.1c.406.62-13.629,8.042-19.82,6.449,0,0-16.147-56.949-17.528-63.97s-4.375-39.717-3.224-47.085-.643-29.776,14.33-29.809",
    transform: "translate(-12.445 -10.149)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7792",
    "data-name": "Path 7792",
    d: "M189.27,278.125a1.422,1.422,0,1,0,.248.221",
    transform: "translate(-14.135 -21.206)",
    fill: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7793",
    "data-name": "Path 7793",
    d: "M189.5,278.333c.019-.019.141.038.272.232a1.447,1.447,0,0,1,.195.958,1.661,1.661,0,0,1-.805,1.241,1.671,1.671,0,0,1-2.282-2.026,1.662,1.662,0,0,1,1.137-.948,1.439,1.439,0,0,1,.973.08c.209.106.28.221.263.242a2.243,2.243,0,0,0-1.131.025,1.356,1.356,0,0,0-.8.768,1.233,1.233,0,0,0,1.621,1.439,1.357,1.357,0,0,0,.667-.886,2.234,2.234,0,0,0-.109-1.125",
    transform: "translate(-14.115 -21.193)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7794",
    "data-name": "Path 7794",
    d: "M187.828,274.1a1.2,1.2,0,1,0,.227,2.067,1.265,1.265,0,0,0-.227-2.067",
    transform: "translate(-14.067 -20.909)",
    fill: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7795",
    "data-name": "Path 7795",
    d: "M187.808,274.085c.01-.026.13-.03.309.079a1.23,1.23,0,0,1,.5.71,1.43,1.43,0,0,1-.254,1.3,1.447,1.447,0,0,1-2.464-1.083,1.43,1.43,0,0,1,.783-1.064,1.227,1.227,0,0,1,.86-.113c.2.058.28.15.267.175-.021.078-.444-.094-.944.252a1.118,1.118,0,0,0-.5.8,1.006,1.006,0,0,0,1.641.721,1.119,1.119,0,0,0,.252-.9c-.084-.6-.5-.8-.454-.866",
    transform: "translate(-14.047 -20.898)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7796",
    "data-name": "Path 7796",
    d: "M186.777,269.994a1.2,1.2,0,1,0,.227,2.067,1.265,1.265,0,0,0-.227-2.067",
    transform: "translate(-13.987 -20.596)",
    fill: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7797",
    "data-name": "Path 7797",
    d: "M186.757,269.984c.01-.026.13-.03.309.078a1.23,1.23,0,0,1,.5.71,1.43,1.43,0,0,1-.254,1.3,1.447,1.447,0,0,1-2.464-1.083,1.432,1.432,0,0,1,.783-1.064,1.221,1.221,0,0,1,.86-.112c.2.057.28.149.267.174-.021.078-.444-.094-.944.252a1.118,1.118,0,0,0-.5.8,1.006,1.006,0,0,0,1.641.721,1.119,1.119,0,0,0,.252-.9c-.084-.6-.5-.8-.454-.866",
    transform: "translate(-13.967 -20.585)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7798",
    "data-name": "Path 7798",
    d: "M165.367,163.4s.008.2,0,.587-.035.964-.026,1.722c.014,1.515.06,3.75.2,6.631.265,5.764.825,14.109,1.652,24.451q.319,3.877.668,8.121.183,2.118.373,4.324.049.55.1,1.107l.049.552.116.539c.145.718.343,1.456.527,2.2,1.516,5.924,3.26,12.24,5.079,18.9l12.063,43.494-.223-.186a21.884,21.884,0,0,0,7.4-.683,38.979,38.979,0,0,0,12.241-5.718l-.1.261c-5.236-23.6-10-45.072-13.8-62.2l-.006-.026v-.025c.587-13.89,1.065-25.211,1.4-33.08.178-3.912.318-6.964.414-9.058q.078-1.537.121-2.362c.03-.533.062-.805.062-.805s.008.274,0,.807q-.024.827-.066,2.365c-.071,2.095-.174,5.149-.3,9.061-.292,7.871-.71,19.2-1.224,33.088l0-.051c3.831,17.121,8.632,38.58,13.91,62.175l.038.167-.134.093a39.463,39.463,0,0,1-12.418,5.8,22.381,22.381,0,0,1-7.577.695l-.176-.018-.046-.169c-4.281-15.5-8.338-30.193-12.016-43.51-1.807-6.666-3.535-12.983-5.034-18.922-.184-.745-.378-1.473-.527-2.23l-.117-.56-.048-.563q-.048-.557-.1-1.108-.183-2.206-.357-4.327-.333-4.241-.636-8.126c-.781-10.347-1.287-18.7-1.492-24.47-.114-2.885-.127-5.124-.109-6.64.006-.758.057-1.336.073-1.724s.048-.585.048-.585",
    transform: "translate(-12.472 -12.373)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7799",
    "data-name": "Path 7799",
    d: "M372.626,188.1c-.082.03-4.249-11.224-9.306-25.133s-9.092-25.214-9.01-25.244,4.248,11.221,9.307,25.136,9.091,25.211,9.009,25.241",
    transform: "translate(-26.899 -10.509)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7800",
    "data-name": "Path 7800",
    d: "M411.435,112.091a.836.836,0,0,1-.017.192c-.02.143-.047.326-.079.557-.08.51-.194,1.227-.337,2.138-.3,1.879-.734,4.558-1.266,7.861-1.061,6.636-2.476,15.813-3.9,25.969s-2.574,19.374-3.373,26.049c-.393,3.322-.713,6.017-.938,7.9-.112.915-.2,1.636-.261,2.148-.031.231-.057.415-.077.558a.954.954,0,0,1-.036.188.8.8,0,0,1,0-.192q.017-.215.044-.561c.048-.514.116-1.236.2-2.155.181-1.871.466-4.578.838-7.919.742-6.68,1.863-15.9,3.282-26.066s2.872-19.334,3.99-25.961c.558-3.315,1.026-5.995,1.364-7.845.169-.908.3-1.62.4-2.127.045-.23.082-.411.111-.552a.919.919,0,0,1,.048-.188",
    transform: "translate(-30.473 -8.553)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7801",
    "data-name": "Path 7801",
    d: "M458.271,153.349c.066.056-6.993,8.54-15.767,18.946s-15.944,18.8-16.011,18.745,6.992-8.538,15.769-18.948,15.943-18.8,16.009-18.743",
    transform: "translate(-32.407 -11.701)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7802",
    "data-name": "Path 7802",
    d: "M350.814,198.116c-.056.066-4.243-3.411-9.35-7.767s-9.2-7.942-9.145-8.008,4.242,3.411,9.35,7.768,9.2,7.941,9.145,8.008",
    transform: "translate(-25.221 -13.913)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7803",
    "data-name": "Path 7803",
    d: "M466.826,211.212c-.006.087-5.522-.236-12.318-.722s-12.3-.95-12.3-1.037,5.521.236,12.319.722,12.3.95,12.3,1.037",
    transform: "translate(-33.606 -15.981)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7804",
    "data-name": "Path 7804",
    d: "M351.7,495.58a11.417,11.417,0,1,0,11.417-11.418A11.417,11.417,0,0,0,351.7,495.58",
    transform: "translate(-26.699 -36.944)",
    fill: "#858d9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7805",
    "data-name": "Path 7805",
    d: "M357.322,496.009a6.222,6.222,0,1,0,6.221-6.221,6.221,6.221,0,0,0-6.221,6.221",
    transform: "translate(-27.129 -37.374)",
    fill: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7806",
    "data-name": "Path 7806",
    d: "M383.507,476.435v7.623L365.8,498.322a6.8,6.8,0,0,1-2.723,1.171c-1.319.141-2.552-.605-2.552-2.56,0-3.712,4.628-14.53,4.628-14.53h3.7v-5.969Z",
    transform: "translate(-27.373 -36.355)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7807",
    "data-name": "Path 7807",
    d: "M362.974,497.5c-.049.033-.224-.446.283-.935a1.162,1.162,0,0,1,1.132-.222,1.22,1.22,0,0,1,0,2.313,1.162,1.162,0,0,1-1.132-.222c-.506-.489-.332-.968-.283-.935.078-.013.1.384.5.647a.83.83,0,0,0,.751.066.769.769,0,0,0,0-1.424.83.83,0,0,0-.751.066c-.406.261-.424.66-.5.647",
    transform: "translate(-27.555 -37.869)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7808",
    "data-name": "Path 7808",
    d: "M365.535,482.882a13.424,13.424,0,0,1,2.691-.165c1.662-.029,3.959-.009,6.492.055l6.485.205a14.794,14.794,0,0,1,2.686.2,13.323,13.323,0,0,1-2.69.165c-1.663.029-3.96.009-6.494-.055l-6.484-.205a14.791,14.791,0,0,1-2.686-.2",
    transform: "translate(-27.755 -36.833)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7809",
    "data-name": "Path 7809",
    d: "M201.83,495.706a11.418,11.418,0,1,0,11.418-11.418,11.418,11.418,0,0,0-11.418,11.418",
    transform: "translate(-15.264 -36.954)",
    fill: "#858d9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7810",
    "data-name": "Path 7810",
    d: "M207.455,496.135a6.222,6.222,0,1,0,6.221-6.221,6.221,6.221,0,0,0-6.221,6.221",
    transform: "translate(-15.693 -37.383)",
    fill: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7811",
    "data-name": "Path 7811",
    d: "M233.641,474.2V484l-17.706,14.264a6.8,6.8,0,0,1-2.723,1.171c-1.319.141-2.552-.605-2.552-2.56,0-3.712,4.628-14.53,4.628-14.53h3.7V474.2Z",
    transform: "translate(-15.937 -36.184)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7812",
    "data-name": "Path 7812",
    d: "M213.108,497.625c-.049.033-.224-.446.283-.935a1.162,1.162,0,0,1,1.132-.222,1.22,1.22,0,0,1,0,2.313,1.162,1.162,0,0,1-1.132-.222c-.506-.489-.332-.968-.283-.935.079-.013.1.384.5.647a.83.83,0,0,0,.751.066.769.769,0,0,0,0-1.424.83.83,0,0,0-.751.066c-.406.261-.424.659-.5.647",
    transform: "translate(-16.119 -37.879)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7813",
    "data-name": "Path 7813",
    d: "M215.669,483.008a13.423,13.423,0,0,1,2.691-.165c1.662-.029,3.959-.009,6.492.055l6.485.205a14.8,14.8,0,0,1,2.686.2,13.321,13.321,0,0,1-2.69.165c-1.663.029-3.96.009-6.494-.054l-6.484-.205a14.794,14.794,0,0,1-2.686-.2",
    transform: "translate(-16.32 -36.843)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7814",
    "data-name": "Path 7814",
    d: "M269.621,410.26a8,8,0,0,1-7.555-5.407l-33.312-97.677,176.712,28.562-4.058,59.649a7.408,7.408,0,0,1-6.893,6.867l-124.382,7.99c-.171.01-.342.017-.513.017M231.679,309.646l32.253,94.571a6.028,6.028,0,0,0,6.075,4.06l124.381-7.99a5.43,5.43,0,0,0,5.053-5.034l3.937-57.854Z",
    transform: "translate(-17.318 -23.439)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7815",
    "data-name": "Path 7815",
    d: "M235.7,329.41l-7.393-5.634L221,302.538l-6.4-3.707.987-1.705,7.038,4.076,7.343,21.368,6.918,5.272Z",
    transform: "translate(-16.238 -22.672)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2882",
    "data-name": "Rectangle 2882",
    width: 1.97,
    height: 168.722,
    transform: "translate(218.938 304.048) rotate(-82.189)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2883",
    "data-name": "Rectangle 2883",
    width: 1.97,
    height: 157.243,
    transform: "translate(228.841 332.872) rotate(-86.605)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2884",
    "data-name": "Rectangle 2884",
    width: 145.368,
    height: 1.972,
    transform: "translate(238.618 359.481) rotate(-1.504)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2885",
    "data-name": "Rectangle 2885",
    width: 138.27,
    height: 1.972,
    transform: "translate(244.973 377.213) rotate(-2.767)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7816",
    "data-name": "Path 7816",
    d: "M401.227,402.69l-1.964-.165c1.847-22.008,3.083-44.361,3.67-66.44l1.971.053c-.588,22.115-1.825,44.507-3.677,66.552",
    transform: "translate(-30.329 -25.645)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7817",
    "data-name": "Path 7817",
    d: "M388.953,403.759l-1.971-.014c0-.465.334-46.746.918-68.7l1.971.053c-.584,21.93-.915,68.193-.918,68.657",
    transform: "translate(-29.392 -25.566)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2886",
    "data-name": "Rectangle 2886",
    width: 1.972,
    height: 72.525,
    transform: "translate(344.118 305.949) rotate(-1.506)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2887",
    "data-name": "Rectangle 2887",
    width: 1.971,
    height: 76.305,
    transform: "matrix(0.997, -0.074, 0.074, 0.997, 327.955, 303.8)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2888",
    "data-name": "Rectangle 2888",
    width: 1.971,
    height: 81.556,
    transform: "matrix(0.991, -0.133, 0.133, 0.991, 308.08, 300.3)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2889",
    "data-name": "Rectangle 2889",
    width: 1.972,
    height: 87.494,
    transform: "translate(286.497 296.363) rotate(-10.585)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2890",
    "data-name": "Rectangle 2890",
    width: 1.972,
    height: 93.188,
    transform: "translate(260.966 293.137) rotate(-14.221)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2891",
    "data-name": "Rectangle 2891",
    width: 1.972,
    height: 106.792,
    transform: "translate(229.002 288.032) rotate(-18.011)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7818",
    "data-name": "Path 7818",
    d: "M378.421,473.693h-.042L217.2,471.062a2.464,2.464,0,0,1-2.423-2.525c.072-2.889.488-17.465,1.611-20.674.4-1.143,1.068-3.054,27.833-16.176,2.657-1.3,26.047-12.729,29.274-12.91,3.345-.187,33.067-1.452,34.331-1.506a2.464,2.464,0,0,1,.21,4.924c-.307.012-30.432,1.294-34.175,1.5-4.225.9-48.322,22.069-52.917,26.141-.485,2.1-.94,9.346-1.168,16.342l158.686,2.589a2.464,2.464,0,0,1-.04,4.928",
    transform: "translate(-16.251 -31.84)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7819",
    "data-name": "Path 7819",
    d: "M312.4,469.777l-20.468-.5c-3.865-.192-6.756-1.339-8.614-3.41-1.759-1.961-2.552-4.667-2.354-8.04a18.345,18.345,0,0,1,2.994-8.81l19.8-29.285,1.632,1.1L285.6,450.1a16.365,16.365,0,0,0-2.672,7.838c-.164,2.83.459,5.054,1.855,6.609,1.5,1.664,3.925,2.593,7.221,2.756l20.442.5Z",
    transform: "translate(-21.299 -32.028)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7820",
    "data-name": "Path 7820",
    d: "M302.226,410.932c-16.494-29.712-59.776-107.368-61.948-109.847-1.315-1.172-11.865-4.885-18.2-6.942l.609-1.874c1.716.557,16.832,5.5,18.941,7.386,2.037,1.82,52.268,92.217,62.317,110.32Z",
    transform: "translate(-16.809 -22.302)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7821",
    "data-name": "Path 7821",
    d: "M224.943,293.278l-10.857,6.6s-12.541-5.673-13.587-7.017-1.343-6.336,2.986-7.273,21.457,7.7,21.457,7.7",
    transform: "translate(-15.112 -21.786)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7822",
    "data-name": "Path 7822",
    d: "M204.395,290.191c-.029,0-.082-.185-.032-.526a2.044,2.044,0,0,1,.733-1.252,2.223,2.223,0,0,1,2.134-.375,2.278,2.278,0,0,1,0,4.3,2.223,2.223,0,0,1-2.134-.375,2.044,2.044,0,0,1-.733-1.252c-.05-.341,0-.526.032-.526s.059.183.161.478a2.069,2.069,0,0,0,.76,1.011,1.885,1.885,0,0,0,1.752.218,1.825,1.825,0,0,0,0-3.414,1.883,1.883,0,0,0-1.751.218,2.066,2.066,0,0,0-.761,1.011c-.1.3-.119.478-.161.478",
    transform: "translate(-15.455 -21.969)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7823",
    "data-name": "Path 7823",
    d: "M217.449,475.037c0-.141,36.019.32,80.433,1.033,44.431.712,80.435,1.4,80.433,1.545s-36.01-.321-80.442-1.033c-44.415-.711-80.427-1.4-80.425-1.545",
    transform: "translate(-16.455 -36.246)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7824",
    "data-name": "Path 7824",
    d: "M453.45,508.989c0,.142-87.853.257-196.2.257-108.384,0-196.218-.115-196.218-.257s87.833-.257,196.218-.257c108.347,0,196.2.115,196.2.257",
    transform: "translate(-4.52 -38.819)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7825",
    "data-name": "Path 7825",
    d: "M142.6,109.454l-7.665-13.508a36.187,36.187,0,1,0-8.668,9.643l-.013.016Z",
    transform: "translate(-5.054 -3.121)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7826",
    "data-name": "Path 7826",
    d: "M142.588,109.44l-16.37-3.744a.107.107,0,0,1-.061-.171l.012-.017.151.151a37.031,37.031,0,0,1-7.431,4.48,36.246,36.246,0,0,1-9.91,2.829,32.6,32.6,0,0,1-5.721.289c-.984-.056-1.986-.079-3-.164l-3.054-.462a36.466,36.466,0,0,1-22.582-14.5,36.027,36.027,0,0,1-6.107-13.961A36.844,36.844,0,0,1,68.945,68.1a35.652,35.652,0,0,1,7.746-14.861l1.476-1.624c.485-.546,1.063-1,1.589-1.5.551-.474,1.047-1.011,1.639-1.429l1.735-1.3a15.326,15.326,0,0,1,1.8-1.188l1.833-1.113,1.919-.932a16.91,16.91,0,0,1,1.938-.861,36.859,36.859,0,0,1,16.2-2.489A35.642,35.642,0,0,1,121.682,45.2a36.67,36.67,0,0,1,17.154,21.107,39.055,39.055,0,0,1,1.57,11.753,35.944,35.944,0,0,1-1.769,10.149,36.663,36.663,0,0,1-3.625,7.777l0-.105,7.574,13.559-7.755-13.456a.1.1,0,0,1,0-.106,36.676,36.676,0,0,0,3.557-7.747,35.823,35.823,0,0,0,1.713-10.077,38.855,38.855,0,0,0-1.594-11.646,36.355,36.355,0,0,0-17.022-20.858,35.3,35.3,0,0,0-14.706-4.327,36.5,36.5,0,0,0-16.009,2.472,16.58,16.58,0,0,0-1.914.853l-1.9.921-1.81,1.1a14.966,14.966,0,0,0-1.774,1.174l-1.713,1.281c-.585.414-1.074.945-1.618,1.412-.519.5-1.092.94-1.57,1.48l-1.459,1.6A35.251,35.251,0,0,0,69.363,68.2a36.46,36.46,0,0,0-.434,15.888A35.665,35.665,0,0,0,74.95,97.9,36.148,36.148,0,0,0,97.273,112.3l3.024.466c1,.087,1.994.113,2.97.172a32.275,32.275,0,0,0,5.673-.268,36.078,36.078,0,0,0,9.842-2.766,37.014,37.014,0,0,0,7.407-4.411.108.108,0,0,1,.151.018.111.111,0,0,1,0,.133l-.013.016-.061-.171,16.321,3.954",
    transform: "translate(-5.039 -3.107)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7827",
    "data-name": "Path 7827",
    d: "M106.324,68.966a11.938,11.938,0,0,0-10.06-13.632,1.187,1.187,0,0,0-.854.1,1.216,1.216,0,0,0-.32,1.15,14.42,14.42,0,0,0,11.219,12.725",
    transform: "translate(-7.118 -4.22)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7828",
    "data-name": "Path 7828",
    d: "M88.928,92.023c3.013,6.206,7.34,10.388,12.7,10.59,1.072.037,1.882-.667,2.906-.727a6.547,6.547,0,0,1,1.715.646,2.408,2.408,0,0,0,.894.2c5.539-.3,10.259-4.2,13.44-10.711,4.43-9.126,3.061-18.93-3.051-21.909a14.548,14.548,0,0,0-2.5-.977,10.281,10.281,0,0,0-3.039-.357,22.708,22.708,0,0,0-6.946,1.571c-.094.037-.2.073-.3.109-4.967-2.193-8.935-2.206-12.782-.346-6.112,2.979-7.471,12.783-3.038,21.909",
    transform: "translate(-6.45 -5.247)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7829",
    "data-name": "Path 7829",
    d: "M89.212,83a4.731,4.731,0,0,1-.508-1.835,9.9,9.9,0,0,1,3.1-8.389,4.712,4.712,0,0,1,1.579-1.063c.042.063-.568.456-1.371,1.278A10.776,10.776,0,0,0,89,81.14c.077,1.146.284,1.842.211,1.863",
    transform: "translate(-6.626 -5.472)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7830",
    "data-name": "Path 7830",
    d: "M90.43,88.466c-.114.026-.31-.4-.439-.962s-.141-1.031-.028-1.057.31.4.44.962.14,1.031.027,1.057",
    transform: "translate(-6.722 -6.596)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7831",
    "data-name": "Path 7831",
    d: "M119.808,53.932c.031.077-1.145.515-2.868,1.546a22.925,22.925,0,0,0-2.863,2.04,22.841,22.841,0,0,0-5.421,6.625,22.842,22.842,0,0,0-1.434,3.21c-.67,1.892-.866,3.132-.948,3.117a3.5,3.5,0,0,1,.094-.877,8.262,8.262,0,0,1,.205-1.013,13.668,13.668,0,0,1,.366-1.323,20.355,20.355,0,0,1,1.374-3.3,21.5,21.5,0,0,1,5.516-6.741,20.4,20.4,0,0,1,2.96-2c.436-.263.861-.444,1.224-.62a8.19,8.19,0,0,1,.953-.4,3.486,3.486,0,0,1,.841-.266",
    transform: "translate(-7.972 -4.115)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7832",
    "data-name": "Path 7832",
    d: "M335.976,85.495a2.17,2.17,0,0,0-2.074.244,4.688,4.688,0,0,0-.457.334,28.362,28.362,0,0,1-17.305,5.546c-12.111,0-22.14-6.79-23.939-15.66V74.281a1.206,1.206,0,1,0-2.413,0v4.7a1.226,1.226,0,0,0,.065.321,14.564,14.564,0,0,0-1.286,5.86c0,10.238,10.848,18.555,24.253,18.555,11.241,0,20.717-5.848,23.459-13.8a.217.217,0,0,0,.06-.122,4.9,4.9,0,0,0,.52-2.041,2.324,2.324,0,0,0-.883-2.254",
    transform: "translate(-21.882 -5.576)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8754",
    "data-name": "Group 8754",
    transform: "translate(269.416 74.96)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8753",
    "data-name": "Group 8753"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8752",
    "data-name": "Group 8752",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7833",
    "data-name": "Path 7833",
    d: "M291.524,81.152s11.414,26.271,42.35,7.859c0,0-7.977,8.279-18.375,10.292-9.392,1.819-23.336-3.484-23.975-18.151",
    transform: "translate(-291.524 -81.152)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_7834",
    "data-name": "Path 7834",
    d: "M340.588,87.828c-.192.454-.933.577-1.652.275s-1.145-.923-.954-1.376.933-.579,1.652-.273,1.147.918.954,1.374",
    transform: "translate(-25.649 -6.584)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7835",
    "data-name": "Path 7835",
    d: "M405.628,233.721a.233.233,0,0,0,.008.046V264.81c0,1.362-1.1,2.768-3.114,3.833a18.841,18.841,0,0,1-8.621,1.8h-.046c-7.346-.015-11.735-2.9-11.735-5.632V233.767a.259.259,0,0,0,.007-.046c0-.016-.007-.039-.007-.062.016-3.036,2.246-6.2,4.49-9.333,1.51-2.089,1.87-5.1,1.94-6.869.008-.212.016-.4.016-.571h-.2a1.641,1.641,0,0,1-1.752-1.5v-1.314a1.641,1.641,0,0,1,1.752-1.509h11.03a1.78,1.78,0,0,1,1.619.915,1.393,1.393,0,0,1,.134.594v1.314a1.641,1.641,0,0,1-1.753,1.5h-.2c0,.172.008.359.016.571.07,1.767.431,4.779,1.941,6.869,2.245,3.129,4.474,6.3,4.49,9.333,0,.023-.008.046-.008.062",
    transform: "translate(-29.021 -16.219)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7836",
    "data-name": "Path 7836",
    d: "M405.607,233.7s0-.107-.028-.317a8.013,8.013,0,0,0-.125-.926,12.1,12.1,0,0,0-1.3-3.351,46.251,46.251,0,0,0-3.189-4.8A13.608,13.608,0,0,1,399,216.868l0-.184.172.016a1.579,1.579,0,0,0,1.766-1.179c.022-.392,0-.877.007-1.319a1.241,1.241,0,0,0-.451-1.082,1.758,1.758,0,0,0-1.192-.389l-1.447,0-2.992.008-6.354.015a1.734,1.734,0,0,0-1.357.481,1.2,1.2,0,0,0-.32.621,7.489,7.489,0,0,0-.018.808c0,.272-.006.6.01.827a1.174,1.174,0,0,0,.307.64,1.732,1.732,0,0,0,1.414.5l.234-.015,0,.246a18.9,18.9,0,0,1-.413,3.785,10.476,10.476,0,0,1-1.487,3.662,29.924,29.924,0,0,0-4.072,6.89,8.252,8.252,0,0,0-.43,1.971c-.035.659-.018,1.389-.022,2.088q0,2.12,0,4.282,0,4.322,0,8.787c0,5.228,0,10.332,0,15.262a9.228,9.228,0,0,0,.079,1.774,3.411,3.411,0,0,0,.822,1.47,8.187,8.187,0,0,0,2.858,1.946,19.284,19.284,0,0,0,6.691,1.374,23.153,23.153,0,0,0,6.5-.587,10.244,10.244,0,0,0,5.3-2.834,3.623,3.623,0,0,0,.69-1.224,4.625,4.625,0,0,0,.114-1.4q0-1.458.008-2.861.008-2.8.017-5.377c.034-6.831.062-12.366.081-16.227.02-1.894.037-3.374.048-4.412.013-1.008.043-1.537.043-1.537a11.054,11.054,0,0,1,.06,1.537c.011,1.037.028,2.518.048,4.412.019,3.86.047,9.4.082,16.227q.007,2.57.017,5.377,0,1.4.007,2.861a5.049,5.049,0,0,1-.125,1.519,4.017,4.017,0,0,1-.763,1.374,10.63,10.63,0,0,1-5.519,3,23.55,23.55,0,0,1-6.633.623,19.685,19.685,0,0,1-6.867-1.4,8.65,8.65,0,0,1-3.035-2.066,3.891,3.891,0,0,1-.936-1.68,9.5,9.5,0,0,1-.1-1.892c0-4.93,0-10.034,0-15.262q0-4.46,0-8.787,0-2.161,0-4.282c0-.716-.013-1.39.026-2.127a8.788,8.788,0,0,1,.459-2.094,30.2,30.2,0,0,1,4.146-7,13.517,13.517,0,0,0,1.836-7.172l.231.23a2.189,2.189,0,0,1-1.751-.655,1.623,1.623,0,0,1-.418-.891c-.023-.341-.006-.587-.01-.882a7.015,7.015,0,0,1,.027-.885,1.64,1.64,0,0,1,.441-.852,2.177,2.177,0,0,1,1.676-.61l6.354.015,2.992.008,1.447,0a2.132,2.132,0,0,1,1.433.486,1.613,1.613,0,0,1,.573,1.365c-.008.465.013.878-.02,1.368a1.918,1.918,0,0,1-2.116,1.465l.167-.167a13.405,13.405,0,0,0,1.845,7.289,44.019,44.019,0,0,1,3.134,4.867,11.567,11.567,0,0,1,1.231,3.42,6.2,6.2,0,0,1,.079.94c.008.212-.006.319-.019.319",
    transform: "translate(-29 -16.201)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7837",
    "data-name": "Path 7837",
    d: "M399.113,217.141a47.08,47.08,0,0,1-9.821,0,47.077,47.077,0,0,1,9.821,0",
    transform: "translate(-29.568 -16.549)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7838",
    "data-name": "Path 7838",
    d: "M404.728,239.807a3.517,3.517,0,0,0-3.365.142,12.648,12.648,0,0,1-3.227,1.4,6.213,6.213,0,0,1-3.945-1.009,24.261,24.261,0,0,0-3.659-1.993,7.119,7.119,0,0,0-7.339,1.728v26.657s1.465,4.548,11.774,3.833,9.5-5.262,9.5-5.262Z",
    transform: "translate(-29.103 -18.158)",
    fill: "#aab2c5"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCart);
export default __webpack_public_path__ + "static/media/Empty_Cart.706ee1b6dbaade1945f932e2c817fab6.svg";
export { ForwardRef as ReactComponent };